import { AgResourceLanguage } from '../types';
import { orderList as EnUsOrderList } from '../en-us/orderList';

export const orderList: AgResourceLanguage['orderList'] = {
  ...EnUsOrderList,
  filterOrders: {
    filterTitle: 'Toon bestellingen voor:',
    filterOptionTitle: 'Alle Abonnementen'
  },
  emptyPastOrders: {
    title: `Je hebt nog geen bestellingen`,
    description: 'Begin met winkelen en bekijk deze pagina later.',
    buttonName: 'Haal Je AG1'
  },
  emptyUpcomingOrders: {
    title: 'Je hebt geen aankomende bestellingen',
    buttonName: 'Haal Je AG1'
  },
  upcomingOrders: {
    title: 'Aankomende Bestellingen',
    card: {
      orderDateLabel: 'Besteldatum',
      subscriptionNameLabel: 'Abonnement',
      subscriptionStatusLabel: 'Status',
      unpaidStatus: 'Onbetaald',
      totalAmountLabel: 'Totaal',
      shipButton: 'Nu Verzenden',
      editDetailsButton: 'Details Bewerken',
      skipShipmentButton: 'Verzending Overslaan'
    }
  },
  pastOrders: {
    title: 'Bestellingen',
    table: {
      idPreSymbol: '#',
      orderNumberColumn: 'Bestelnummer',
      dateColumn: 'Datum',
      subscriptionNameColumn: 'Abonnement',
      statusColumn: 'Status',
      totalColumn: 'Totaal',
      trackButton: 'Bestelling Volgen',
      oneTimeLabel: 'Eenmalige aankoop'
    },
    card: {
      idPreSymbol: '#',
      orderLabel: 'Bestelling',
      dateLabel: 'Datum:',
      subscriptionLabel: 'Abonnement',
      statusLabel: 'Status',
      totalLabel: 'Totaal',
      trackButtonMobile: 'Bestelling Volgen',
      trackButtonTablet: 'Bestelling Volgen',
      viewDetailsButton: 'Details Bekijken'
    }
  }
};
